import { InfoCircle } from '@aktiia/design-system';

import { ModalName, PatientsSortBy } from '../../../../../enums';
import { useOpenModal } from '../../../../../features/modals';
import { PatientsSort } from '../patients-sort';

export const BpStatusSort = () => {
  const openAktiiaStatusModal = useOpenModal(ModalName.AKTIIA_STATUS);

  return (
    <div className="flex items-center cursor-pointer">
      <InfoCircle className="mr-2 scale-75" onClick={() => openAktiiaStatusModal()} />
      <PatientsSort by={PatientsSortBy.BP_TYPE} />
    </div>
  );
};
